

















import { Vue, Component, Prop } from "vue-property-decorator";
import { ListDisplayMode } from "@/data/constants";

// Enums/Data
import { ProductTypes } from "@/data/enums/products";
import { ProvisionCategoryCodes } from "@/modules/web_hosting/data/enums";

@Component({
  components: {
    "catalogue-provider": () =>
      import("@/components/app/admin/catalogue/catalogueProvider.vue"),
    "product-search": () =>
      import("@/components/app/admin/catalogue/productSearch.vue")
  }
})
export default class WebHostingPackages extends Vue {
  // Props

  @Prop({ required: true })
  public categoryCode!: ProvisionCategoryCodes;

  // Data

  public availableModes = [ListDisplayMode.GRID];
  public productTypes = [
    ProductTypes.SINGLE_PRODUCT,
    ProductTypes.PRODUCT_BUNDLE
  ];
}
